function getCookie(name) {
    let arr;
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) return arr[2];
    else return null;
}
(function (para) {
    var p = para.sdk_url,
        n = para.name,
        w = window,
        d = document,
        s = 'script',
        x = null,
        y = null;
    if (typeof w['sensorsDataAnalytic201505'] !== 'undefined') {
        return false;
    }
    w['sensorsDataAnalytic201505'] = n;
    w[n] =
        w[n] ||
        function (a) {
            return function () {
                (w[n]._q = w[n]._q || []).push([a, arguments]);
            };
        };
    var ifs = [
        'track',
        'quick',
        'register',
        'registerPage',
        'registerOnce',
        'clearAllRegister',
        'trackSignup',
        'trackAbtest',
        'setProfile',
        'setOnceProfile',
        'appendProfile',
        'incrementProfile',
        'deleteProfile',
        'unsetProfile',
        'identify',
        'login',
        'logout',
        'trackLink',
        'clearAllRegister',
        'getAppStatus'
    ];
    for (var i = 0; i < ifs.length; i++) {
        w[n][ifs[i]] = w[n].call(null, ifs[i]);
    }
    if (!w[n]._t) {
        // (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0]);
        // x.async = 1;
        // x.src = p;
        // x.setAttribute('charset', 'UTF-8');
        // y.parentNode.insertBefore(x, y);
        w[n].para = para;
    }
})({
    heatmap_url: 'https://pssweb.ppdai.com/loanapp/util/heatmap.min.js',
    sdk_url: 'https://pssweb.ppdai.com/loanapp/util/sensorsdata.min.js',
    name: 'sa',
    encrypt_cookie: true,
    is_secure_cookie: true, // 神策cookie增加secure配置
    // 配置打通 App 与 H5 的参数
    use_app_track: !window.noInLoanApp,
    server_url:
        window.server_url ||
        'https://sensorsdata.ppdai.com/sa/?project=production',
    scrollmap: {}, // 触达图
    heatmap: {
        //是否开启点击图，默认 default 表示开启，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.7
        clickmap: 'default',
        //是否开启触达注意力图，默认 default 表示开启，可以设置 'not_collect' 表示关闭
        //需要 JSSDK 版本号大于 1.9.1
        scroll_notice_map: 'default',
        //设置多少毫秒后开始渲染点击图,因为刚打开页面时候页面有些元素还没加载
        loadTimeout: 3000,
        //用户点击（a，button，input）这些元素时会触发这个函数，让你来判断是否要采集当前这个元素，返回真表示采集，返回假表示不采集。
        //不设置这个函数，默认是采集 a button input 这些标签。
        collect_element: function (element_target) {
            // 如果这个元素有属性sensors-disable=true时候，不采集
            if (element_target.getAttribute('sensors-disable') === 'true') {
                return false;
            } else {
                return true;
            }
        },
        //考虑到用户隐私，这里可以设置input里的内容是否采集
        //如果返回真，表示采集input内容，返回假表示不采集input内容,默认不采集
        collect_input: function (element_target) {
            //例如如果元素的id是a，就采集这个元素里的内容
            if (element_target.id === 'a') {
                return true;
            }
        },
        //假如要在 $WebClick 事件增加自定义属性，可以通过（a，button，input）这三类标签的特征来判断是否要增加
        custom_property: function (element_target) {
            //比如您需要给有 data=test 属性的标签的点击事件增加自定义属性 name:'aa' ，则代码如下
            if (element_target.getAttribute('data') === 'test') {
                return {
                    name: 'aa'
                };
            }
        },
        //SDK默认优先以元素ID作为选择器采集点击事件，若不想以ID作为选择器，可以设置该参数为'not_use_id'（1.12.1以上版本支持）
        element_selector: 'not_use_id',
        //第二版点击图滚动滚动条，改变页面尺寸后延时多少毫秒重新渲染页面
        renderRefreshTime: 1000,
        // 设置触达图的有效停留时间，默认超过2秒以上算有效停留
        scroll_delay_time: 2000
    }
});
let registerPageParam = {
    product: 'super_app', // 产品线名称，对应各个产品线，借款app对应loan_app,没有则传other
    platform: 'H5', // 平台类型H5
    h5_channel: '', // h5页面来源渠道，如果h5是app内部打开就传空字符串
    user_agent: window.navigator.userAgent, // http头中的useragent字段
    source: 'App_H5',
    product_h5: 'other',
    url: window.location.href,
    ...(getCookie('tagged') ? { tgt_type: getCookie('tagged') } : {})
}
const { userAgent } = window.navigator;
if (
        window.__wxjs_environment === 'miniprogram' ||
        (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)) || (/toutiaomicroapp/i.test(userAgent))
) {
     
    registerPageParam.platform = getCookie('miniappPlatform') || '';
    registerPageParam.param31 = getCookie('miniappToken') || ''
    registerPageParam.param32 = getCookie('miniappId') || ''
    registerPageParam.param33 = getCookie('miniappSourceId') || ''
    registerPageParam.param34 = getCookie('miniappScene') || ''
    registerPageParam.param35 = getCookie('miniAppVersion') || ''
    registerPageParam.param36 = getCookie('messageVersion') || ''
    registerPageParam.oid = getCookie('miniAppOid') || ''
}

sa.registerPage(registerPageParam);
var eventNameObj = {
    click: 'h5_clk',
    input: 'h5_input',
    imp: 'h5_element_imp',
    auth: 'h5_auth',
    banner: 'h5_banner_clk',
    mpclick: 'MP_clk',
    mpinput: 'MP_input',
    mpimp: 'MP_element_imp',
    mpauth: 'MP_auth',
};
var initSensor = function () {
    if (window.PPDWebUI && window.PPDWebUI.os.inApp) {
        eventNameObj = {
            click: 'app_clk',
            input: 'app_input',
            imp: 'app_element_imp',
            auth: 'app_auth',
            banner: 'app_banner_clk',
            interface: 'app_interface_request'
        };
        login();
    } else {
        if (getCookie('miniappChannel')) {
            let miniAppOpenId = getCookie('miniAppOpenId');
            miniAppOpenId && sa.login(miniAppOpenId);
        }
        // sa.quick('autoTrack');
    }
};
var login = function () {
    if (window.PPDWebUI && window.PPDWebUI.os.inApp) {
        if (getCookie('token')) {
            window.PPDWebUI.appInfos && window.PPDWebUI.appInfos.openid && sa.login(window.PPDWebUI.appInfos.openid);
            window.PPDWebUI.appInfos && window.PPDWebUI.appInfos.distinctId && sa.identify(window.PPDWebUI.appInfos.distinctId);
            PPDWebUI.TrackService.getTrackData(function (res) {
                sa.identify(res.distinctId);
                sa.login(res.userName);
            });
        } else {
            sa.logout();
            window.PPDWebUI.appInfos && window.PPDWebUI.appInfos.distinctId && sa.identify(window.PPDWebUI.appInfos.distinctId);
            PPDWebUI.TrackService.getTrackData(function (res) {
                sa.identify(res.distinctId);
            });
        }
    }
}
//直接上报到app下
if (window.directPointApp) {
    eventNameObj = {
        click: 'app_clk',
        input: 'app_input',
        imp: 'app_element_imp',
        auth: 'app_auth',
        banner: 'app_banner_clk',
        interface: 'app_interface_request'
    };
}
if (!window.noInLoanApp) {
    if (!window.PPDWebUI) {
        var count = 10;
        var clock = setInterval(function () {
            count--;
            if (window.PPDWebUI) {
                clearInterval(clock);
                initSensor();
            }
            if (count < 0) {
                clearInterval(clock);
            }
        }, 300);
    } else {
        initSensor();
    }
}
var SA = {
    disposeParam: function (data) {
        //处理数据
        var obj = {};
        for (var key in data) {
            var isNum = key.match(/^num[0-9]*$/);
            var isDate = key.match(/^date[0-9]*$/);
            var isParam = key.match(/^param[0-9]*$/);
            if (data[key] == null) {
                delete obj[key];
            } else if (key == 'bizId' || key == 'bizid') {
                obj['bizId'] = data[key];
            } else if (isNum) {
                var numval = String(data[key])
                    .replace(/[\%￥\a-zA-Z"]/g, '')
                    .match(/\d*(\.\d+)?/)[0];
                obj[key] = numval == '' ? null : Number(numval);
            } else if (isDate) {
                obj[key] = data[key];
            } else if (isParam) {
                obj[key] = String(data[key]);
                obj[key] = obj[key];
            } else {
                obj[key] = String(data[key]);
            }
        }
        return obj;
    },
    h5_clk: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.click, obj);
    },
    h5_input: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.input, obj);
    },
    h5_element_imp: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.imp, obj);
    },
    h5_auth: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.auth, obj);
    },
    h5_banner_clk: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.banner, obj);
    },
    app_interface_request: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.interface, obj);
    },
    mp_clk: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.mpclick, obj);
    },
    mp_input: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.mpinput, obj);
    },
    mp_element_imp: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.mpimp, obj);
    },
    mp_auth: function (data) {
        var obj = this.disposeParam(data);
        sa.track(eventNameObj.mpauth, obj);
    },
    login: login
};

// 支持vue等使用
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = SA;
    }
    exports.SA = SA;
} else {
    window.SA = SA;
}
// };

export default SA;
